<template>
  <div class="home">
    <Header></Header>
    <Banners :banner="banner"></Banners>

    <div class="part1">
      <ul>
        <li v-for="item in part1">
          <img :src="item.imgUrl" />
          <p class="name">{{item.name}}</p>
          <p class="remark">{{item.remark}}</p>
        </li>
      </ul>
      <div class="clear"></div>
    </div>

    <div class="part2">
      <p class="title">技术与服务精炼</p>
      <p class="text">基于大数据分析的精准用户推广</p>
      <ul>
        <li v-for="item in part2">
          <img :src="item.imgUrl" />
          <p class="name">{{item.name}}</p>
          <p class="remark">{{item.remark}}</p>
        </li>
      </ul>
      <div class="clear"></div>
    </div>

    <div class="part3">
      <p class="title">公司荣誉</p>
      <img class="img3" :src="img3" @click="noClick"/>
      <table cellspacing="0">
        <tr>
          <td>江苏省民营科技企业称号</td>
          <td>苏州大学研究所工作站</td>
        </tr>
        <tr>
          <td>江苏省高新技术企业</td>
          <td>苏州市互联网协会高级会员</td>
        </tr>
        <tr>
          <td>CSEEA软件企业证书</td>
          <td>中信银行2017年度优秀合作伙伴</td>
        </tr>
        <tr>
          <td>苏州市软件行业协会会员单位</td>
          <td>中国电信集团黄页信息业务合作商</td>
        </tr>
        <tr>
          <td>浦发银行中信银行数据交互企业</td>
          <td>苏州大学产学研示范基地</td>
        </tr>
      </table>
      <div class="clear"></div>
    </div>

    <div class="part4">
      <p class="title">合作机构</p>
      <ul>
        <li v-for="item in part4">
          <img :src="item.imgUrl" />
        </li>
      </ul>
      <div class="clear"></div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
  import Header from "@/mComponents/Header"
  import Banners from "@/mComponents/Banners"
  import Footer from "@/mComponents/Footer"

  export default {
    name: 'Home',
    data() {
      return {
        banner: require("@/assets/imgs/mobile/banner-01.png"),
        img3: require("@/assets/imgs/mobile/img-cup.png"),
        part1: [
          {imgUrl:require("@/assets/imgs/mobile/ic-top-client.png"),name:"客户第一",remark:"深入客户、服务客户、成就客户"},
          {imgUrl:require("@/assets/imgs/mobile/ic-top-teamwork.png"),name:"团队合作",remark:"包容互助、共担共享、一起成就"},
          {imgUrl:require("@/assets/imgs/mobile/ic-top-simple.png"),name:"简化",remark:"诚实正直、直言不讳、结果导向"},
          {imgUrl:require("@/assets/imgs/mobile/ic-top-passion.png"),name:"激情",remark:"热爱工作、积极生活、挑战困难"},
          {imgUrl:require("@/assets/imgs/mobile/ic-top-study.png"),name:"教学相长",remark:"专注专业、虚心请教、主动分享"},
          {imgUrl:require("@/assets/imgs/mobile/ic-top-innovate.png"),name:"创新",remark:"善于学习、拥抱变化、创造变化"},
          ],
        part2: [
          {imgUrl:require("@/assets/imgs/mobile/ic-home-userportrait.png"),name:"用户画像",remark:"让您了解TA"},
          {imgUrl:require("@/assets/imgs/mobile/ic-home-select-crowd.png"),name:"圈定人群",remark:"圈定人群"},
          {imgUrl:require("@/assets/imgs/mobile/ic-home-user-push.png"),name:"用户推送",remark:"让您影响TA"},
          {imgUrl:require("@/assets/imgs/mobile/ic-home-effect-optimize.png"),name:"效果优化",remark:"让您影响更多的TA"},
          ],
        part4:[
          {imgUrl:require("@/assets/imgs/mobile/01.png")},
          {imgUrl:require("@/assets/imgs/mobile/02.png")},
          {imgUrl:require("@/assets/imgs/mobile/03.png")},
          {imgUrl:require("@/assets/imgs/mobile/04.png")},
          {imgUrl:require("@/assets/imgs/mobile/05.png")},
          {imgUrl:require("@/assets/imgs/mobile/06.png")},
          {imgUrl:require("@/assets/imgs/mobile/07.png")},
          {imgUrl:require("@/assets/imgs/mobile/08.png")},
          {imgUrl:require("@/assets/imgs/mobile/09.png")},
          {imgUrl:require("@/assets/imgs/mobile/10.png")},
          {imgUrl:require("@/assets/imgs/mobile/11.png")},
          {imgUrl:require("@/assets/imgs/mobile/12.png")},
          {imgUrl:require("@/assets/imgs/mobile/13.png")},
          {imgUrl:require("@/assets/imgs/mobile/14.png")},
          {imgUrl:require("@/assets/imgs/mobile/15.png")},
          {imgUrl:require("@/assets/imgs/mobile/16.png")},
          {imgUrl:require("@/assets/imgs/mobile/17.png")},
          {imgUrl:require("@/assets/imgs/mobile/18.png")},
          {imgUrl:require("@/assets/imgs/mobile/19.png")},
          {imgUrl:require("@/assets/imgs/mobile/20.png")},
          {imgUrl:require("@/assets/imgs/mobile/21.png")},
          {imgUrl:require("@/assets/imgs/mobile/22.png")},
          {imgUrl:require("@/assets/imgs/mobile/23.png")},
          {imgUrl:require("@/assets/imgs/mobile/24.png")},
          {imgUrl:require("@/assets/imgs/mobile/26.png")},
          {imgUrl:require("@/assets/imgs/mobile/27.png")},
          {imgUrl:require("@/assets/imgs/mobile/28.png")},
          {imgUrl:require("@/assets/imgs/mobile/29.png")},
          {imgUrl:require("@/assets/imgs/mobile/30.png")},
          {imgUrl:require("@/assets/imgs/mobile/31.png")},
          {imgUrl:require("@/assets/imgs/mobile/32.png")},
          {imgUrl:require("@/assets/imgs/mobile/33.png")},
          {imgUrl:require("@/assets/imgs/mobile/34.png")},
          ],
      }
    },
    components: {
      Header,Banners,Footer,
    },
    created() {
      window.scrollTo(0,0);
      this.$store.commit('changeNavsM', 'mHome')
    },
    methods: {
      noClick() {
        return false;
      }
    },
    mounted() {
      $('.part1 ul li').addClass("active");
      var screenHeight =  document.documentElement.clientHeight
      setTimeout(function() {
        window.onscroll = function() {
          var bool = $(window).scrollTop()+$(window).height()==$(document).height();
          var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          let fontSize = getComputedStyle(window.document.documentElement)['font-size'];
          if(scrollTop>30) {
            $(".icon-m-up").css("display","block")
            $(".top").addClass("active")
          } else {
            $(".icon-m-up").css("display","none")
            $(".top").removeClass("active")
          }

          if(scrollTop> (2.4* parseInt(fontSize))) {
            $('.part2 ul li:nth-child(1),.part2 ul li:nth-child(2)').addClass('active')
          }
          if(scrollTop> (4.3* parseInt(fontSize))) {
            $('.part2 ul li:nth-child(3),.part2 ul li:nth-child(4)').addClass('active')
          }

          var lis = $('.part4 ul li')
          for(var i =0;i<lis.length;i++) {
            var offsetTop = $(lis[i]).offset().top
            if(offsetTop - scrollTop - screenHeight < 0 && !bool && !$(lis[i]).hasClass('active')) {
              $(lis[i]).addClass('active')
            }
          }
        }
      },100)
    }
  }
</script>

<style  scoped lang="scss" type="text/scss">
  @import '../../assets/css/animation.css';

  .home {
    background-color: #fff;

    .clear {
      clear: both;
    }

    .part1 {
      padding-bottom: 0.7rem;
      ul {
        margin: 0 0.45rem;
        min-height: 8rem;
        li {
          width: 3rem;
          height: 2.4rem;
          background:rgba(238,238,238,1);
          border-radius:8px;
          float: left;
          margin: 0.3rem 0.15rem 0;
          &.active img{
             -moz-animation: RotateY 0.5s linear forwards;
             -ms-animation: RotateY 0.5s linear forwards;
             -webkit-animation: RotateY 0.5s linear forwards;
             -o-animation: RotateY 0.5s linear forwards;
             animation: RotateY 0.5s linear forwards;
           }
          img {
            display: block;
            width: 2.8rem;
            margin: 0.1rem auto 0;
            min-height: 1rem;
            transform:RotateY(90deg);
            -ms-transform:RotateY(90deg); 	/* IE 9 */
            -moz-transform:RotateY(90deg); 	/* Firefox */
            -webkit-transform:RotateY(90deg); /* Safari 和 Chrome */
            -o-transform:RotateY(90deg); 	/* Opera */
          }
          p {
            text-align: center;
          }
          .name {
            font-size:0.24rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(0,0,0,1);
            margin: 0.03rem 0;
          }
          .remark {
            font-size:0.18rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(0,0,0,1);
            opacity:0.6;
          }
        }
      }
    }

    .part2 {
      padding-bottom: 0.5rem;
      padding-top: 0.45rem;
      background:rgba(237,237,237,1);
      p {
        text-align: center;
      }
      .title {
        font-size:0.4rem;
        line-height: 0.5rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
      }
      .text {
        font-size:0.3rem;
        line-height: 0.5rem;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(0,0,0,1);
        opacity:0.6;
      }
      ul {
        margin: 0.2rem 0.45rem 0;
        display: inline-block;
        li {
          width: 3rem;
          float: left;
          margin: 0.3rem 0.15rem 0;
          &.active img {
             -moz-animation: RotateY 0.5s linear forwards;
             -ms-animation: RotateY 0.5s linear forwards;
             -webkit-animation: RotateY 0.5s linear forwards;
             -o-animation: RotateY 0.5s linear forwards;
             animation: RotateY 0.5s linear forwards;
           }
          img {
            opacity: 0;
            display: block;
            width: 1.92rem;
            margin: 0.1rem auto 0;
            transform:RotateY(90deg);
            -ms-transform:RotateY(90deg); 	/* IE 9 */
            -moz-transform:RotateY(90deg); 	/* Firefox */
            -webkit-transform:RotateY(90deg); /* Safari 和 Chrome */
            -o-transform:RotateY(90deg); 	/* Opera */
          }
          .name {
            font-size:0.24rem;
            line-height: 0.55rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(0,0,0,1);
            margin: 0.03rem 0;
          }
          .remark {
            font-size:0.18rem;
            line-height: 0.3rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(136,136,136,1);
          }
        }
      }
    }

    .part3 {
      background:#fff;
      padding: 0.45rem 0;
      .title {
        font-size:0.4rem;
        line-height: 0.6rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
      }
      .img3 {
        width: 3.8rem;
        display: block;
        margin: 0.4rem auto 0.5rem;
      }
      table {
        margin: 0 0.3rem;
        border-top:0.01rem solid rgba(204,204,204,1);
        border-left:0.01rem solid rgba(204,204,204,1);
        tr {
          td {
            width: 3.45rem;
            height: 0.7rem;
            line-height: 0.7rem;
            font-size: 0.2rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(40,40,40,1);
            padding-left: 0.2rem;
            box-sizing: border-box;
            border-bottom:0.01rem solid rgba(204,204,204,1);
            border-right:0.01rem solid rgba(204,204,204,1);
          }
        }
      }
    }

    .part4 {
      padding: 0.5rem 0 0.8rem;
      background:rgba(237,237,237,1);
      p {
        text-align: center;
      }
      .title {
        font-size:0.4rem;
        line-height: 0.6rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
      }
      ul {
        margin: 0 0.65rem;
        li {
          float: left;
          width: 2.8rem;
          height: 0.8rem;
          margin: 0.3rem 0.15rem 0;
          &.active img{
             -moz-animation: RotateY 0.5s linear forwards;
             -ms-animation: RotateY 0.5s linear forwards;
             -webkit-animation: RotateY 0.5s linear forwards;
             -o-animation: RotateY 0.5s linear forwards;
             animation: RotateY 0.5s linear forwards;
          }
          img {
            opacity: 0;
            width: 2.8rem;
            display: inline-block;
            transform:RotateY(90deg);
            -ms-transform:RotateY(90deg); 	/* IE 9 */
            -moz-transform:RotateY(90deg); 	/* Firefox */
            -webkit-transform:RotateY(90deg); /* Safari 和 Chrome */
            -o-transform:RotateY(90deg); 	/* Opera */
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Mobile/Home.vue